module.exports = __webpack_public_path__ + "static/img/资金结算.dd050481.png";